import { clearAddItemError, fetchPreviouslyOrderedItems } from '../../../redux/modules/neworder';
import { loggedIn } from '../../../routes/conditional';
import { chainAPIActions } from '../../../redux/middleware/chain';
import paths from '../../../routes/paths';
import { addReorderItems } from '../../../redux/modules/orders';

export const page = {
  path: paths.createOrder.reorder,
  isAllowed: [loggedIn],
  action: () => chainAPIActions(fetchPreviouslyOrderedItems()),
};

export const addMedicine = {
  actionPath: '/actions/add-medicine',
  inputName: 'medicine',
  mapMedicineToInputValue: m => JSON.stringify(m),
  action: ({ body }) => {
    let medicines = null;
    try {
      const rawMedicines = Array.isArray(body.medicine)
        ? body.medicine
        : [body.medicine];
      medicines = rawMedicines.map(m => JSON.parse(m));
    } catch (e) {
      // none
    }
    return addReorderItems(medicines, true);
  },
};

export const clearSelectionError = {
  actionPath: '/actions/clear-selection-error',
  action: () => clearAddItemError(),
};